module.exports = __webpack_public_path__ + "static/malevich-d012f10fc45888cf6bf72949ee244d25.svg";